import React from 'react'
import classNames from 'classnames'
import { HiChevronLeft }  from "react-icons/hi"

const Prev = props => {

	const { currentPage, pagerClass, onPrev } = props

	const disabled = currentPage <= 1 

	const onPrevClick = e => {
		if(disabled) {
			return 
		}
		onPrev(e)
	}

	const pagerPrevClass = classNames(
		pagerClass.default, 
		'pagination-pager-prev', 
		disabled ? pagerClass.disabled : pagerClass.inactive
	)

	return (
		<span className={`${pagerPrevClass} ${!disabled && 'hover:bg-newBlue hover:text-white' }`} onClick={onPrevClick}>
			<HiChevronLeft />
			<span className="inline-block sm:hidden">Previous</span>
		</span>
	)
}

export default Prev
